<template>
  <footer class="footer">
    <app-container class="footer__container">
      <div class="contacts">
        <h3 class="footer__title">Контакты</h3>
        <p class="contacts__description">
          8 (800) 775 53 81 ООО «ЮМАКС» <br>
          105062, г. Москва, Подсосенский переулок, д. 23, стр. 5, этаж 2, пом. 1
        </p>
      </div>
      <div class="social">
        <h3 class="footer__title">Соц. Сети</h3>
        <ul class="social-icons">
          <li
            v-for="(icon, index) in icons"
            :key="index"
          >
            <a
              class="social-icons__item"
              target="_blank"
              :href="`${icon.link}`"
            >
              <component :is="icon.logo"/>
            </a>
          </li>
          <a
            class="social-icons__link"
            href="https://sk.ru/news/"
            target="_blank"
          >
            <img
              class="social-icons__image"
              src="../../assets/images/sk.png"
              alt
            >
          </a>
        </ul>
      </div>
      <div class="licens">
        <h3 class="footer__title licens__title">Лицензии</h3>
        <a
          class="licens__link"
          @click.prevent="openLicense"
        >
          <img
            class="licens__image"
            src="../../assets/images/license.png"
            alt
          >
        </a>
      </div>
    </app-container>
  </footer>
</template>

<script>
import IconInstagram from '../Icons/IconInstagram';
import IconVkontakte from '../Icons/IconVk.vue';
import IconYoutube from '../Icons/IconYoutube.vue';
import IconFacebook from '../Icons/IconFacebook.vue';
import AppContainer from '../Base/AppContainer.vue';

export default {
  name: 'AppFooter',
  components: {
    IconInstagram,
    IconVkontakte,
    IconYoutube,
    IconFacebook,
    AppContainer,
  },
  data() {
    return {
      icons: [
        {
          link: 'https://vk.com/maximumtest',
          logo: IconVkontakte,
        },
        {
          link: 'https://www.facebook.com/maximumtest',
          logo: IconFacebook,
        },
        {
          link: 'https://www.instagram.com/maximumtestru/?hl=ru',
          logo: IconInstagram,
        },
        {
          link: 'https://www.youtube.com/user/MaximumtestRu/videos',
          logo: IconYoutube,
        },
      ],
    };
  },
  methods: {
    openLicense() {
      window.open('full-license.jpg', 'popUpWindow', 'height=450,width=960');
    },
  },
};
</script>

<style lang="scss" scoped>
  .footer {
    background: #182138;
    color: #fff;
    flex-shrink: 0;

    &__title {
      font-size: 25px;
      letter-spacing: 0.38px;
      margin: 0;
      padding: 20px 0 10px 0;
    }

    &__container {
      display: flex;
      justify-content: space-between;
      padding: 30px 0 50px 0;
    }
  }

  .social {
    text-align: center;

    &-icons {
      display: flex;
      justify-content: space-between;
      align-items: center;
      list-style-type: none;
      &__item {
        margin: 0 12px;
        color: #fff;
      }
    }
  }

  .licens {
    &__title {
      text-align: right;
    }
    &__link {
      justify-content: end;
    }
    &__image {
      width: 80px;
      height: 115px;
    }
  }

  @media (max-width: 992px) {
    .licens {
      text-align: end;
    }
  }

  @media (max-width: 576px) {
    .footer {
      padding: 10px 0;
      &__container {
        flex-direction: column;
      }
      &__title {
        text-align: left;
      }
    }
    .social {
      &__title {
        text-align: left;
      }
      &-icons {
        padding: 0;
        justify-content: flex-start;
        &__item {
          margin: 0 24px 0 0;
        }
      }
    }
    .licens {
      text-align: start;
      &__link {
        margin: 0 10px 0 0;
      }
    }
  }
</style>
